import React from "react";
import { MenuIcon, PanelsTopLeft } from "lucide-react";

import { Button } from "../ui/button";

import { Menu } from "./menu";
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from "../ui/sheet";
import { Link } from "react-router-dom";
import Logo from "../../assets/svg/logo.svg";

export function SheetMenu() {
  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button className="h-8" variant="outline" size="icon">
          <MenuIcon size={20} />
        </Button>
      </SheetTrigger>
      <SheetContent className="sm:w-72 px-3 h-full flex flex-col" side="left">
        <SheetHeader>
          <Button
            className="flex justify-center items-center pb-2 pt-1"
            variant="link"
            asChild
          >
            <Link to="/" className="flex items-center gap-2 mt-5">
              <div className="w-40">
                <img src={Logo} alt="logo" />
              </div>
            </Link>
          </Button>
        </SheetHeader>
        <Menu isOpen />
      </SheetContent>
    </Sheet>
  );
}
